import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const DashboardStore = {
    state: {
        banners: [],
        dashboardStateCounters: null,
        deliveryTimeStats: null,
        topFrequentCustomers: [],
        repurchaseStats: null,
        deliveriesByCommune: [],
        monthlyDeliveries: [],
        topStoresByDeliveries: null,
        dashboardFilters: { from: null, to: null }
    },
    getters,
    mutations,
    actions
}

export default DashboardStore
